import * as React from 'react';
import SecuredPage from 'Views/Components/Security/SecuredPage';
import NotificationRedirect from 'Views/Components/_HumanWritten/NotificationRedirect/NotificationRedirect';
import { SecuredGroups } from 'Models/Security/UserGroups';

function NotificationRedirectPage() {
	return (
		<SecuredPage groups={SecuredGroups.create.onlyLoggedIn().groups}>
			<div className="body-content">
				<NotificationRedirect />
			</div>
		</SecuredPage>
	);
}

export default NotificationRedirectPage;
